import { render, staticRenderFns } from "./custom-footer.vue?vue&type=template&id=d2675c74&"
import script from "./custom-footer.vue?vue&type=script&lang=js&"
export * from "./custom-footer.vue?vue&type=script&lang=js&"
import style0 from "./custom-footer.vue?vue&type=style&index=0&id=d2675c74&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports